module.exports = __webpack_public_path__ + "static/media/le.c6d9cc84.ogg";